'use client';

import React from 'react';
import { useDrawer } from 'src/hooks/drawers/useDrawer';
import useTableFilterSelections from 'src/hooks/filters/useTableFilterSelections';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/pro-solid-svg-icons';

interface EmptyGroupHeaderProps {
  location: string;
  onTransitionStart?: () => void;
  onRefresh?: () => void; // Add new prop for immediate refresh
}

const EmptyGroupHeader: React.FC<EmptyGroupHeaderProps> = ({
  location,
  onTransitionStart,
  onRefresh,
}) => {
  const { closeAllButCurrent } = useDrawer();
  const { setColumnId } = useTableFilterSelections(location);

  return (
    <div className="flex items-center justify-center w-full">
      <button
        className="self-stretch px-4 py-1.5 bg-teal-600 rounded-full 
  inline-flex justify-between items-center hover:bg-teal-500"
        onClick={(e) => {
          e.stopPropagation();

          // Call onTransitionStart if provided
          if (onTransitionStart) {
            onTransitionStart();
          }

          // First open the drawer
          closeAllButCurrent(`table-volume-${location}`);

          // Set column ID immediately without delay
          setColumnId(null);

          // Call onRefresh immediately to force update
          if (onRefresh) {
            onRefresh();
          }
        }}
      >
        <div className="flex justify-start items-center gap-1">
          <div className="w-4 h-5 flex items-center justify-center">
            <Icon icon={faPlus} className="w-3 h-3 text-white" />
          </div>
          <div className="justify-start text-white text-sm font-semibold font-['Inter'] leading-tight">
            Add Code Set
          </div>
        </div>
      </button>
    </div>
  );
};

export default EmptyGroupHeader;
